import React from "react";
import {
  FiLayers,
  FiTrendingUp,
  FiClock,
  FiEdit3,
  FiCheckCircle,
  FiShield,
} from "react-icons/fi";
import "./WhatYouGet.css";

const WhatYouGet = () => {
  return (
    <section className="oglitz-design-dark-whatyouget">
      <div className="oglitz-design-dark-whatyouget__container">
        {/* Header */}
        <div className="oglitz-design-dark-whatyouget__header">
          <span className="oglitz-design-dark-whatyouget__badge">
            What You Get
          </span>

          <h2 className="oglitz-design-dark-whatyouget__title">
            Premium Design Deliverables
            <span> Built for Real Business Growth</span>
          </h2>

          <p className="oglitz-design-dark-whatyouget__subtitle">
            Everything included in our design packages is crafted to help your
            brand look professional, consistent, and conversion-focused.
          </p>
        </div>

        {/* Grid */}
        <div className="oglitz-design-dark-whatyouget__grid">
          <Feature icon={<FiLayers />} title="Strategic Design System" />
          <Feature icon={<FiTrendingUp />} title="Growth-Driven Creatives" />
          <Feature icon={<FiClock />} title="Fast Turnaround Time" />
          <Feature icon={<FiEdit3 />} title="Revisions Included" />
          <Feature icon={<FiCheckCircle />} title="Production-Ready Assets" />
          <Feature icon={<FiShield />} title="Professional Support" />
        </div>
      </div>
    </section>
  );
};

const Feature = ({ icon, title }) => {
  return (
    <div className="oglitz-design-dark-whatyouget__card">
      <div className="oglitz-design-dark-whatyouget__icon">{icon}</div>
      <h4 className="oglitz-design-dark-whatyouget__card-title">{title}</h4>
      <p className="oglitz-design-dark-whatyouget__card-text">
        Designed with clarity, consistency, and performance in mind.
      </p>
    </div>
  );
};

export default WhatYouGet;
